<div class="container">
  <app-casa-personal-profile-form
    role="teacher"
    [personDetails]="personDetails"
    [sensitiveDetails]="sensitiveDetails"
    [settings]="settings"
    [address]="address"
    [photo]="photo"
    [contacts]="contacts"
    (savePersonDetails)="savePersonDetails($event)"
    (saveSensitiveDetails)="saveSensitiveDetails($event)"
    (saveSettings)="saveSettings($event)"
    (saveAddress)="saveAddress($event)"
    (saveContacts)="saveContacts($event)"
    (savePhoto)="savePhoto($event)"
    [busy]="activeSubscriptions > 0"
  >
    <div form-header class="card-header border-bottom border-secondary pb-4">
      <h5 class="mb-0">Teacher's personal details</h5>
    </div>
    <div class="card mb-5" additional-card>
      <div class="card-header border-bottom border-secondary pb-4">
        <h5 class="mb-0">Teacher's language profile</h5>
      </div>
      <div class="card-body">
        <app-manager-casa-teacher-profile
          [busy]="teacherBusy"
          [profile]="teacherProfileUnderEdit"
          [courseProfiles]="teacherCourseProfilesUnderEdit"
          (saveProfile)="saveTeacherProfile($event)"
          (saveCourseProfile)="saveTeacherCourseProfile($event)"
          (deleteCourseProfile)="deleteCourseProfile($event)"
        ></app-manager-casa-teacher-profile>
      </div>
    </div>
  </app-casa-personal-profile-form>
</div>
